import { render, staticRenderFns } from "./platformByProductOrderDetail.vue?vue&type=template&id=add98a2a&scoped=true"
import script from "./platformByProductOrderDetail.vue?vue&type=script&lang=js"
export * from "./platformByProductOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./platformByProductOrderDetail.vue?vue&type=style&index=0&id=add98a2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add98a2a",
  null
  
)

export default component.exports